export const throughput = {
   id: "throughput",
   title: "Throughput",
   family: "throughput",
   endpoint: "/runthroughput.sz",
   defaultSort: { key: "process_date", dir: "desc" },
   groupBy: ["process_date"],
   groupOptions: [
      { value: "process_date", label: "Date" },
      { value: "location",     label: "Location" },
      { value: "status",       label: "Status" },
   ],
   categoryField: "status",
   categoryLabel: "Status",
   minField: "duration_sec",
   params: [
      { key: "period", type: "month", label: "Period" },
      { key: "locations", type: "multiselect", label: "Locations" },
   ],
   summary: [
      { key: "docs",        label: "Documents",   type: "int", agg: "count" },
      { key: "completed",   label: "Completed",   type: "int", agg: "countWhere", column: "status", equals: "COMPLETE" },
      { key: "in_progress", label: "In progress", type: "int", agg: "countWhere", column: "status", equals: "IN_PROGRESS" },
   ],
   columns: [
      { key: "process_date", label: "Date",        type: "date", align: "left" },
      { key: "doc_ref",      label: "Document",    type: "text", align: "left" },
      { key: "location",     label: "Location",    type: "text", align: "left" },
      { key: "steps_done",   label: "Steps done",  type: "int",  align: "right" },
      { key: "final_step",   label: "Final step",  type: "label", align: "left" },
      { key: "duration_sec", label: "Duration",    type: "duration", align: "right" },
      { key: "status",       label: "Status",      type: "label", align: "left" },
   ],
};
